import Variants from './variants';

const variants = new Variants();

export default variants;



// WEBPACK FOOTER //
// ./static/js/v0/variants/index.js